module.exports = __webpack_public_path__ + "media/media/product-card/heavy__vlsat_base_empty-46c2c82c0e6df0240870bfa254aec99c.jpg";